import {ConfigObjectType} from '@wallaby-ui/core';
import * as React from 'react';

import UploadLayout from './UploadLayout';

type Props = {config: ConfigObjectType};
export const UploadLayoutContainer: React.FC<Props> = (props) => {
  return <UploadLayout {...props} />;
};
